var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.src
    ? _c(
        "Modal",
        {
          ref: "modal",
          attrs: {
            "overlay-type": _vm.modalName,
            "html-classes": ["hide--header", "show--modal"],
            "initial-visible": _vm.initialVisible,
            light: "",
            "full-height": ""
          }
        },
        [
          _vm.src
            ? _c("iframe", {
                staticClass: "overlay-dialog__iframe",
                attrs: { src: _vm.src, frameborder: "0" }
              })
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }